export enum SearchQueryKeyEnum {
  Post = "post",
  User = "user",
  Tag = "tag",
  Channel = "channel",
}
